import { IRegistrationContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const RegistrationContext = createContext<IRegistrationContextData>({} as IRegistrationContextData);
